import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

export function useScrollTracking(): (name: string, trackingData?: Record<string, string>) => void {
	const track = useTracking();

	return useCallback(
		(name: string, trackingData) => {
			void track(name, trackingData);
		},
		[track],
	);
}
